import { ServiceType } from 'types/common/service';

export const DEFAULT_COMMENT_INFO = {
  adminScreen: '',
  commentText: '',
  histories: [],
  id: '',
  keys: { userid: '' },
  partitionKey: '',
  tags: '',
  writeAt: '',
  writeBy: '',
  serviceType: ServiceType.GENERAL,
};
